export default __webpack_public_path__ + "8bd7d3a18c460a9e1ef2487824f8f036.svg";